import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, share } from 'rxjs/operators';
export const valve$ = new Subject(false);
export const createValveControl$ = ()=>{
    const distinctValve$ = valve$.pipe(distinctUntilChanged(), share());
    const open$ = distinctValve$.pipe(filter((v)=>!v));
    const close$ = distinctValve$.pipe(filter((v)=>v));
    return {
        open$,
        close$
    };
};
export const openValve = ()=>valve$.next(false);
export const closeValve = ()=>valve$.next(true);
export const setValveValue = (value)=>valve$.next(value);
